import { ADD_CARD, GET_CARDS } from '../actions';
const initialState = {
  addedCard:null,
  loading: false,
  addedCardError:null,
  cards:[],
  getCardsError:null
};

function paymentReducer(state = initialState, action) {
  let addedCard,cards;

  switch (action.type) {
    case `${ADD_CARD}_PENDING`:
    case `${GET_CARDS}_PENDING`:
        return { ...state, loading: true };

    case `${ADD_CARD}_FULFILLED`:
        addedCard = action.payload.data;
        return { ...state, loading: false, addedCard };
    case `${GET_CARDS}_FULFILLED`:
        cards = action.payload.data;
        return { ...state, loading: false, cards };

    case `${ADD_CARD}_REJECTED`:
        return {...state, loading: false, addedCardError: `${action.payload.message}`, state: initialState };
    case `${GET_CARDS}_REJECTED`:
        return {...state, loading: false, getCardsError: `${action.payload.message}`, state: initialState };

    default:
        return state;
  }
}

export default paymentReducer;
